const AGENT_BASE = window._env_?.REACT_APP_TEMPLATE_AGENT_URL || 'http://localhost:8001';
const DATA_ENGINE_BASE = window._env_?.REACT_APP_DATA_ENGINE_URL || 'http://localhost:8002';

export const dataViewApi = {
  getViews: async (orgId, userId) => {
    const r = await fetch(`${DATA_ENGINE_BASE}/api/data-views?org_id=${orgId}&user_id=${userId}`);
    if (!r.ok) throw new Error(`Failed to fetch views: ${r.status}`);
    const json = await r.json();
    return json.data || json;
  },

  getView: async (id) => {
    const r = await fetch(`${DATA_ENGINE_BASE}/api/data-views/${id}`);
    if (!r.ok) throw new Error(`Failed to fetch view: ${r.status}`);
    const json = await r.json();
    return json.data || json;
  },

  createView: async (payload, userId = 'admin', orgId = 'default') => {
    const r = await fetch(`${DATA_ENGINE_BASE}/api/data-views`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-User-Id': userId, 'X-Org-Id': orgId },
      body: JSON.stringify(payload),
    });
    if (!r.ok) throw new Error(`Failed to create view: ${r.status}`);
    const json = await r.json();
    return json.data || json;
  },

  updateView: async (id, payload, userId = 'admin', orgId = 'default') => {
    const r = await fetch(`${DATA_ENGINE_BASE}/api/data-views/${id}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json', 'X-User-Id': userId, 'X-Org-Id': orgId },
      body: JSON.stringify(payload),
    });
    if (!r.ok) throw new Error(`Failed to update view: ${r.status}`);
    const json = await r.json();
    return json.data || json;
  },

  deleteView: async (id, userId = 'admin', orgId = 'default') => {
    const r = await fetch(`${DATA_ENGINE_BASE}/api/data-views/${id}`, {
      method: 'DELETE',
      headers: { 'X-User-Id': userId, 'X-Org-Id': orgId },
    });
    if (!r.ok) throw new Error(`Failed to delete view: ${r.status}`);
    return true;
  },

  executeView: async (id, userId = 'admin', orgId = 'default', parameters = null) => {
    const body = parameters ? { parameters } : undefined;
    const r = await fetch(`${DATA_ENGINE_BASE}/api/data-views/${id}/execute`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-User-Id': userId, 'X-Org-Id': orgId },
      body: body ? JSON.stringify(body) : undefined,
    });
    if (!r.ok) throw new Error(`Failed to execute view: ${r.status}`);
    const json = await r.json();
    return json.data || json;
  },

  executeViewToStep: async (id, stepOrder, userId = 'admin', orgId = 'default') => {
    const r = await fetch(`${DATA_ENGINE_BASE}/api/data-views/${id}/execute/${stepOrder}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-User-Id': userId, 'X-Org-Id': orgId },
    });
    if (!r.ok) throw new Error(`Failed to execute to step: ${r.status}`);
    const json = await r.json();
    return json.data || json;
  },

  executeDraft: async (payload, userId = 'admin', orgId = 'default') => {
    const r = await fetch(`${DATA_ENGINE_BASE}/api/data-views/execute-draft`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-User-Id': userId, 'X-Org-Id': orgId },
      body: JSON.stringify(payload),
    });
    if (!r.ok) throw new Error(`Failed to execute draft: ${r.status}`);
    const json = await r.json();
    return json.data || json;
  },

  streamChat: (body, signal) => {
    return fetch(`${AGENT_BASE}/chat/data-view`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'text/event-stream' },
      body: JSON.stringify(body),
      signal,
    });
  },

  getThreads: async (userId = 'admin') => {
    const r = await fetch(`${AGENT_BASE}/threads?user_id=${userId}&agent=data-view`);
    if (!r.ok) throw new Error(`Failed to fetch threads: ${r.status}`);
    return r.json();
  },

  getThread: async (threadId, userId = 'admin') => {
    const r = await fetch(`${AGENT_BASE}/threads/${threadId}?user_id=${userId}`);
    if (!r.ok) throw new Error(`Failed to fetch thread: ${r.status}`);
    return r.json();
  },

  getModels: async () => {
    const r = await fetch(`${AGENT_BASE}/models`);
    if (!r.ok) throw new Error(`Failed to fetch models: ${r.status}`);
    return r.json();
  },

  listKpis: async (orgId = 'default') => {
    const r = await fetch(`${DATA_ENGINE_BASE}/api/kpis?org_id=${orgId}`);
    if (!r.ok) return [];
    const json = await r.json();
    return json.data || [];
  },

  exportToSheet: async (title, columns, rows) => {
    const r = await fetch(`${DATA_ENGINE_BASE}/api/export/google-sheet`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        title,
        sheets: [{
          name: 'Data',
          sections: [{ title, columns, rows: rows.map(row => columns.map(col => row[col] ?? null)) }],
        }],
      }),
    });
    if (!r.ok) throw new Error(`Export failed: ${r.status}`);
    const json = await r.json();
    return json.data || json;
  },
};
